module.exports = __webpack_public_path__ + "static/media/facebook.70367378.svg";